<template>
  <div class="p-12">
    <h3 class="font-bold mb-12">Edit Subscription</h3>

    <div>
      <EditAccountSubscriptionForm
        v-if="isReady"
        :account-subscription="accountSubscription"
        :agency-options="agencyOptions"
        :billing-period-options="billingPeriodOptions"
        :membership-product-options="membershipProductOptions"
        @edit-account-subscription-form:cancel="doGoBack"
        @edit-account-subscription-form:updated="doGoBack"
      />
    </div>
  </div>
</template>

<script>
import { middleware } from '@/routes/guards';
import EditAccountSubscriptionForm from '@/components/AccountSubscriptions/EditAccountAccountSubscriptionForm.vue';
import { accountSubscriptionsClient } from '@/api/clients';

const STATUS_IDLE = 'idle';
const STATUS_READY = 'ready';

export default {
  name: 'AccountAccountSubscriptionEditPage',

  components: {
    EditAccountSubscriptionForm,
  },

  props: {
    accountSubscriptionUuid: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      status: STATUS_IDLE,
      accountSubscription: null,
      agencyOptions: [],
      billingPeriodOptions: [],
      membershipProductOptions: [],
    };
  },

  computed: {
    isReady() {
      return this.status === STATUS_READY;
    },
  },

  beforeRouteEnter(to, from, next) {
    const check = middleware('account-permission:update account subscriptions');

    check(to, from, async (args) => {
      if (typeof args !== 'undefined') {
        return next(...args);
      }

      try {
        const { data = {} } = await accountSubscriptionsClient.edit(
          to.params.accountSubscriptionUuid
        );

        return next((vm) => {
          vm.setData(data);
        });
      } catch (error) {
        return next(false);
      }
    });
  },

  methods: {
    setData(data) {
      this.accountSubscription = data.data;
      this.agencyOptions = data?.agency_options || [];
      this.billingPeriodOptions = data?.billing_period_options || [];
      this.membershipProductOptions = data?.membership_product_options || [];
      this.status = STATUS_READY;
    },
    doGoBack() {
      this.$router.back();
    },
  },
};
</script>
